export { default } from './ResourcesSection';
